import { render, staticRenderFns } from "./screenQueue.vue?vue&type=template&id=01e7a312&scoped=true&"
import script from "./screenQueue.vue?vue&type=script&lang=js&"
export * from "./screenQueue.vue?vue&type=script&lang=js&"
import style0 from "./screenQueue.vue?vue&type=style&index=0&id=01e7a312&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e7a312",
  null
  
)

export default component.exports